import { useTranslation } from 'next-i18next';

const useTranslateSelectedSegments = () => {
  const { t } = useTranslation('routes');

  const translateSelectedSegments = (path, selectedindexesToTranslate) => {
    let translatedUrl = '';
    const splittedUrl = path.url.slice(1).split('/');
    splittedUrl.forEach((segment, index) => {
      if (selectedindexesToTranslate.includes(index)) {
        translatedUrl += `/${t(`routes:${segment}`)}`;
      } else translatedUrl += `/${segment}`;
    });
    return {
      ...path,
      url: translatedUrl,
    };
  };

  return { translateSelectedSegments };
};

export default useTranslateSelectedSegments;
